import { Send, Loader2, Paperclip } from "lucide-react";
import { TRANSLATIONS } from "@/i18n";
import { TOP_MODE_COLORS } from "@/constants/diplomate";

/**
 * InputPanel — shared across the 4 top modes.
 * Labels, placeholder, and CTA adapt to (topMode, mode).
 */
export const InputPanel = ({ lang, topMode, mode, text, onChange, onGenerate, loading }) => {
  const t = TRANSLATIONS[lang];

  const label =
    topMode === "reverse"
      ? t.inputLabelReverse
      : topMode === "antidote"
      ? t.inputLabelAntidote
      : topMode === "bullshit"
      ? t.inputLabelBullshit
      : mode === "reformulate"
      ? t.inputLabelReformulate
      : t.inputLabelReply;

  const placeholder =
    topMode === "reverse"
      ? t.reversePlaceholder
      : topMode === "antidote"
      ? t.antidotePlaceholder
      : topMode === "bullshit"
      ? t.bullshitPlaceholder
      : mode === "reformulate"
      ? t.inputPlaceholderReformulate
      : t.inputPlaceholderReply;

  const cta =
    topMode === "reverse"
      ? t.reverseCta
      : topMode === "antidote"
      ? t.antidoteCta
      : topMode === "bullshit"
      ? t.bullshitCta
      : t.generate;

  const ctaColor = TOP_MODE_COLORS[topMode] || "#B5EAD7";

  return (
    <div className="bg-white border-2 border-black nb-shadow relative flex flex-col">
      <div className="flex items-center justify-between border-b-2 border-black px-5 py-3 bg-[#F3EFE7]">
        <div className="flex items-center gap-2">
          <Paperclip className="w-3.5 h-3.5 text-black" />
          <span className="font-mono text-[11px] uppercase tracking-widest font-bold">
            {label}
          </span>
        </div>
        <span className="dossier-tag hidden sm:block">Formulaire A · Ligne 1</span>
      </div>
      <textarea
        data-testid="input-textarea"
        value={text}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={label}
        className="w-full min-h-[220px] sm:min-h-[280px] bg-white px-5 py-4 font-normal text-base leading-relaxed focus:outline-none resize-none placeholder:text-[#9A9A9A] placeholder:italic"
      />
      <div className="flex items-center justify-between border-t-2 border-black px-5 py-3 bg-[#F3EFE7] gap-3">
        <span className="font-mono text-[11px] uppercase tracking-widest text-[#4A4A4A]">
          {text.length} {t.charsLabel} / 4000
        </span>
        <button
          data-testid="generate-btn"
          onClick={onGenerate}
          disabled={loading}
          className="border-2 border-black nb-shadow nb-hover px-5 py-2.5 font-bold text-black flex items-center gap-2 text-sm sm:text-base disabled:opacity-70 disabled:cursor-not-allowed"
          style={{ background: ctaColor }}
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              {t.generating}
            </>
          ) : (
            <>
              <Send className="w-4 h-4" strokeWidth={2.5} />
              {cta}
            </>
          )}
        </button>
      </div>
    </div>
  );
};
